let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kDPsc"), load("fOy1c")]).then(() => parcelRequire('71rIN'));